<div class="example-container shareable-component">
  <mat-sidenav-container class="example-sidenav-container">
    <mat-sidenav
      opened
      #snav
      mode="side"
      class="left-sidebar"
      disableClose
      [ngClass]="{ mobileSidenav: mobileQuery.matches, isOpened: false }"
    >
      <div class="sidenav-header" style="justify-content: center">
        <ng-container>
          <span
            class="sidenav-header-black_square"
            *ngIf="!mobileQuery.matches"
          ></span>
          <img
            src="../../assets/img/login_logo_v2.svg"
            style="width: 22px; height: 22px; border-radius: 6px"
            class="sidenav-main-image"
          />
          <h3>Behamics</h3>
        </ng-container>
      </div>
      <div class="sidenav-header_hr"></div>
      <div class="master-admin-nav" style="display: flex; align-items: stretch">
        <mat-nav-list
          style="
            padding: 0;
            flex: 1;
            min-height: 300px;
            overflow: auto;
            display: flex;
            flex-direction: column;
          "
        >
          <ng-container *ngFor="let item of navigationLinksFiltered">
            <a
              mat-list-item
              [routerLink]="null"
              class="nav-item"
              [ngClass]="{
                disabled: !item.active,
                'active-route': item.active,
              }"
            >
              <div class="nav-item-icon_container">
                <img
                  [src]="item?.icon?.src"
                  [style]="item?.icon?.inlineStyle"
                />
              </div>
              <span>
                {{ item.title }}
              </span>
            </a>
            <a
              mat-list-item
              routerLinkActive="active-route"
              class="seven-days-free-trial"
              style="margin-top: auto"
              (click)="openHubspot()"
            >
              <div class="seven-days-free-trial-background"></div>
              <div class="nav-item-icon_container">
                <mat-icon class="list-icon">workspace_premium</mat-icon>
              </div>
              <span>
                <span> Fix the issues </span>
              </span>
            </a>
          </ng-container>
        </mat-nav-list>
      </div>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="custom_sidenav_background"></div>
      <div class="mat-sidenav-content_container">
        <div class="sidenav-main_container" *ngIf="firstLoad">
          <div class="sidenav-tabs_container sidenav-tabs_container-no_tabs">
            <div class="skeleton-box-square" fxFlex="100">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  height: '30px',
                  width: '250px',
                  outline: 'none',
                  'background-color': '#37474f1a',
                }"
              ></ngx-skeleton-loader>
            </div>
          </div>

          <div class="ai-audit-sidenav-content" style="margin-top: 20px">
            <div class="skeleton-box-square">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  height: '150px',
                  outline: 'none',
                  'background-color': '#37474f1a',
                }"
              ></ngx-skeleton-loader>
            </div>
            <div class="skeleton-box-square" style="margin-top: 20px">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  height: '250px',
                  outline: 'none',
                  'background-color': '#37474f1a',
                }"
              ></ngx-skeleton-loader>
            </div>
          </div>
        </div>
        <div
          class="sidenav-main_container"
          [ngStyle]="{ opacity: firstLoad ? 0 : 1 }"
        >
          <div class="sidenav-tabs_container has_own_tabs">
            <div class="sidenav-tabs_container-title-container">
              <h3>
                Website Audit for
                {{
                  selectedTask?.website_name ||
                    selectedTask?.formatted_domain ||
                    selectedTask?.domain
                }}
              </h3>

              <a
                class="behamics_link"
                href="https://behamics.com"
                target="_blank"
              >
                Visit Behamics
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path
                    d="M40,22H15.66L26.83,10.83,24,8,8,24,24,40l2.83-2.83L15.66,26H40V22Z"
                    transform="translate(40 40) rotate(180)"
                  ></path>
                </svg>
              </a>
            </div>
          </div>

          <div class="ai-audit-sidenav-content">
            <app-website-audit></app-website-audit>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
